import React from 'react'

export interface IContainer {
  title?: string
  empty?: string
  action?: React.ReactNode
  children: React.ReactNode
}

const Container = ({ title, action, children, empty }: IContainer) => {
  return (
    <div className="rounded-lg bg-navy-blue p-8">
      {title && (
        <div className="mb-12 flex items-center justify-between">
          <h2 className="text-white">{title}</h2>
          <div className="flex flex-row gap-4">{action}</div>
        </div>
      )}
      {children}
      {empty && (
        <div className="rounded-md bg-white bg-opacity-10 px-4 py-8 text-center text-lg text-white">
          {empty}
        </div>
      )}
    </div>
  )
}

export default Container
